import React from 'react';
import { withStyles, Tabs, Tab } from '@material-ui/core';
import { compose } from 'recompose';
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import ShowHideColumns from '../../../../layout/layoutHeader/showHideColumns';
import SearchBox from '../../../common/SearchBox';
import SaveAltSharp from '@material-ui/icons/SaveAltSharp';
import StyledToolTip from '../../../common/StyledToolTip';
import styles from './styles';
import appConstants from '../../../../appConstants';
import EditIcon from '@material-ui/icons/Edit';
import WatchTutorial from '../../../InAppTutorial/WatchTutorial';
import { getAppTutorialComponentId } from './utils/utils';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const AssetGridHeader = ({
  classes,
  handleTabChange,
  tabId,
  gridApi,
  userData,
  onShowMapToggleClick,
  showTrailerMap,
  updateSearchText,
  exportCSV,
  inputText,
  isAssetUpdateFormOpen,
  selectedAssets,
  openAssetUpdateForm,
  validAssetList,
  keyId,
  validAssetIdList,
  enabledEquipmentUpdate
}) => {
  const tabClasses = { root: classes.tabRoot, selected: classes.tabSelected };
  const getIconTitle = () => {
    if(!enabledEquipmentUpdate){
      return 'Update Asset (Disabled)';
    }
    if (isAssetUpdateFormOpen) {
      return 'Update in progress';
    }
    if (!disableEditIcon) {
      return 'Click to edit';
    } else {
      if (selectedAssets?.length > 0 && !validAssetIdList.includes(selectedAssets[0])) {
        return 'The properties of this asset cannot be updated.';
      }
      return 'Select a single row to edit';
    }
  };

  const disableEditIcon = !enabledEquipmentUpdate ||
    !selectedAssets?.length ||
    isAssetUpdateFormOpen ||
    selectedAssets?.length > 1 ||
    !validAssetIdList.includes(selectedAssets[0]);

  const handleEditAssetForm = () => {
    if (!disableEditIcon) {
      const assetInfo = validAssetList.find((asset) => asset[keyId] === selectedAssets[0]) || null;
      openAssetUpdateForm(assetInfo);
    }
  };

  return (
    <div className={classes.headerStyle} key={tabId}>
      <span>
        <Tabs
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabsIndicator
          }}
          value={tabId}
          onChange={handleTabChange}>
          {appConstants.EQUIPMENT_TAB_NAME.map((tabName, index) => (
            <Tab key={index} classes={tabClasses} disableRipple label={tabName} />
          ))}
        </Tabs>
      </span>
      <div className={classes.iconContainer}>
        {tabId === 0 && !showTrailerMap && (
          <span>
            <div
              className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${classes.toggleAnimationButtonMenu} `}>
              <div className={classes.toggleText}>{`${showTrailerMap ? 'Hide' : 'Show'} Map`}</div>
              <ToggleRenderer
                value={showTrailerMap}
                onChange={() => onShowMapToggleClick(showTrailerMap)}
              />
            </div>
          </span>
        )}
        <span>
          <SearchBox onChange={updateSearchText} inputText={inputText} />
        </span>
        <ClearAllFilterButton gridApi={gridApi} />
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout} ${
            disableEditIcon ? classes.disableIcon : classes.enableIcon
          }`}
          onClick={handleEditAssetForm}>
          <StyledToolTip title={getIconTitle()}>
            <EditIcon />
          </StyledToolTip>
        </span>
        <span className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}>
          <ShowHideColumns api={gridApi} userData={userData} />
        </span>
        <span
          onClick={exportCSV}
          className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}>
          <StyledToolTip title="Export Data">
            <SaveAltSharp />
          </StyledToolTip>
        </span>
        <WatchTutorial
          componentId={getAppTutorialComponentId(tabId)}
          classes={{ headerIconStyles: classes.headerIconStyles, iconLayout: classes.iconLayout }}
        />
      </div>
    </div>
  );
};

export default compose(withStyles(styles))(AssetGridHeader);
